import React, { useContext, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Accordion, Card } from 'react-bootstrap';
import Select from 'react-select';
import ButtonCompontent from './ActionComponent';
import { addDocumentTypeMaster, fetchDocumentType, fetchManualDocumentType, addManualDocumentTypeMaster } from '../Store/SystemMasters.action';
// eslint-disable-next-line import/no-cycle
import CardContent from './CardContent';
import { Context } from './ContextWrapper';
import Loader from '../../../Components/Utility/Loader/Loader';
import { SystemMasterSelect } from '../../../Components/helper';
import * as action from '../../UserSetting/store/User.action';
import CustomTooltip from '../../../Components/Tooltip/CustomTooltip';

function DocumentTypeMaster() {
  const PCTypeOptions = [
    { name: 'Supplier Document Type', value: 'supplier', type: 1 },
    { name: 'Specification Document Type', value: 'specification', type: 1 },
    { name: 'Manual Document Type', value: 'manual', type: 1 },
  ];
  const {
    addNewItem,
    cards,
    updateSubmitState,
    formState,
    MasterAddEditAccess,
    OpenReArrangeFunction,
    setFormState,
    documentMasterTypes,
    handleDropdownChange,
  } = useContext(Context);
  const dispatch = useDispatch();
  const { t } = useTranslation('common');

  const [openCard, setOpenCard] = useState(false);

  const switchCardState = () => {
    setOpenCard((prev) => !prev);
  };

  const handleClick = async () => {
    try {
      setFormState((otherData) => ({ ...otherData, isLoading: true }));
      updateSubmitState(true);
      if (Object.keys(formState?.errors)?.length) {
        setFormState((otherData) => ({ ...otherData, isLoading: false }));
        return;
      }
      const ew = cards.map((obj) => {
        if (obj._id.includes('_id')) {
          return { ...obj, _id: '' };
        }
        return obj;
      });
      if (documentMasterTypes?.value === 'specification') {
        const objData = {
          names: JSON.stringify(ew),
          section: 'masters',
          module: 'documentType',
          action: 'addEdit',
        };
        await dispatch(addDocumentTypeMaster(objData, t));
        await dispatch(fetchDocumentType({}, t));
        updateSubmitState(false);
      } else if (documentMasterTypes?.value === 'supplier' && !ew.some((item) => !item.productType)) {
        const res = await dispatch(action.addUserDocumentsList(ew, t, 'add/update'));
        if (res) await dispatch(action.fetchUserDocumentsList({ fromMaster: 'true' }));
        updateSubmitState(false);
      } else if (documentMasterTypes?.value === 'manual') {
        const objData = {
          names: JSON.stringify(ew),
          section: 'masters',
          module: 'documentType',
          action: 'addEdit',
        };
        await dispatch(addManualDocumentTypeMaster(objData, t));
        await dispatch(fetchManualDocumentType({}, t));
        updateSubmitState(false);
      }
      setFormState((otherData) => ({ ...otherData, isLoading: false }));
    } catch (error) {
      console.log('error', error);
    }
  };

  return (
    <Accordion className="mb-4 master-accordian">
      <Card>
        <Card.Header>
          <div className="title-container">
            <p>{t('DOCUMENT_TYPE.DOCUMENT_TYPE_TITLE')}</p>
          </div>
          <div className="action-title-btns">
            {MasterAddEditAccess && (
              <button
                type="button"
                onClick={() => OpenReArrangeFunction(documentMasterTypes?.value === 'manual' ? 'manualDocumentType' : 'documentType')}
                className="filter-btn filter-button_add"
                disabled={formState?.isLoading || formState?.disableBtn}
                aria-label="Rearrange"
                title={t('DOCUMENT_TYPE.REARRANGE')}
              >
                <span className="icon-expand" />
              </button>
            )}
            {MasterAddEditAccess && (
              <ButtonCompontent
                icon="icon-add"
                isDisabled={formState?.isLoading || formState?.disableBtn}
                tooltipText={t('DOCUMENT_TYPE.ADD')}
                show
                onClick={addNewItem}
              />
            )}
            <ButtonCompontent
              icon={openCard ? 'icon-new-up' : 'icon-new-down'}
              isDisabled={false}
              tooltipText={openCard ? t('DOCUMENT_TYPE.CLOSE') : t('DOCUMENT_TYPE.OPEN')}
              show
              onClick={switchCardState}
            />
          </div>
        </Card.Header>
        {openCard ? (
          <Card.Body>
            <div className="select-container">
              <Select
                options={PCTypeOptions}
                placeholder={t('PRODUCT_COMPONENT_TYPE.SELECT_PLACEHOLDER')}
                getOptionLabel={(option) => `${option.name}`}
                getOptionValue={(option) => `${option.value}`}
                name="PCType"
                value={Object.keys(documentMasterTypes)?.length > 0 ? documentMasterTypes : null}
                styles={SystemMasterSelect}
                onChange={(e) => handleDropdownChange(e, 'PCType')}
              />
            </div>
            {formState?.isLoading ? (
              <Loader />
            ) : (
              <>
                <CardContent documentMasterTypes={documentMasterTypes} />
                {MasterAddEditAccess && (
                  <div className="section-save">
                    <CustomTooltip tooltipText={t('common:COMMON_LABEL.SAVE')}>
                      <button className="btn btn-page-filter btn-white" type="submit" onClick={handleClick} disabled={cards?.length === 0} aria-label="Save">
                        <span className="icon-Save c-button-align f-20 mr-2" /> {t('PRODUCT_IDENTIFIER.SAVE')}
                      </button>
                    </CustomTooltip>
                  </div>
                )}
              </>
            )}
          </Card.Body>
        ) : null}
      </Card>
    </Accordion>
  );
}

export default DocumentTypeMaster;
